// Use VUE_APP_ENDPOINTS for endpoint selection (set by serve:prod script)
// Falls back to NODE_ENV for backwards compatibility
const useDevEndpoints = process.env.VUE_APP_ENDPOINTS 
  ? process.env.VUE_APP_ENDPOINTS !== 'production'
  : process.env.NODE_ENV === 'development';

export const AppSyncConfig = {
  graphqlEndpoint: useDevEndpoints
    ? 'https://4mtyioftuncyll6x4xlsaafjt4.appsync-api.us-east-1.amazonaws.com/graphql'
    : 'https://xarmlusdjfdzjkab4ptvf5yqye.appsync-api.us-east-1.amazonaws.com/graphql',
  region: 'us-east-1',
  userPoolId: useDevEndpoints
    ? 'us-east-1_Xz9dktnrO'      // v3-dev user pool (eyejack-api-v3-dev trusts this)
    : 'us-east-1_XPmiYIn8g',     // prod user pool
  userPoolWebClientId: useDevEndpoints
    ? '252s65e5micbldt90pepjpobu8'   // EyeJack-UserPoolClient-v3-dev
    : '4d0adt7dq74darboj9ctpgbni'    // prod web client
};
